module.exports = __webpack_public_path__ + "assets/img/icon3.0652a5aa.svg";